import gql from 'graphql-tag';

import gbxMetaTagsQuery from './shared/gbxMetaTagsQuery';

const GET_ONE_CLICK_LANDING_PAGE = gql`
  query getOneClickLandingPage {
    me {
      subscriptions {
        id
        program
        status
        shippingAddress {
          country
        }
      }
      layout {
        rebootRename: globalVariable(key: "PUBLIC_SUB_REBOOT_RENAME_ON")
        useNewMembershipConfirmationPage
        gbxOneClickUpgradePage {
          cmsIdentifier
          landingHeroMobileImg {
            src
            alt
            width
            height
          }
          landingHeroDesktopImg {
            src
            alt
            width
            height
          }
          landingHeader
          landingExplanatory
          landingValueProperty
          landingExplanation
          landingButtonCta
          landingChargeCopy
          checkoutSubscriptionDisclaimer
          checkoutShippingDisclaimer
          landingLearnMoreHeader
          landingLearnMoreExplanatory
          landingLearnMoreBulletPoints
          landingErrorMsg
          checkoutBannerText
          noThanksCta
          landingBulletsPoints
        }
        paymentRetrialEnabled: globalVariable(
          key: "PUBLIC_PAYMENT_RETRIAL_EXPERIENCE"
        )
        consent: vcmsAsset(
          structure: "TextAsset"
          properties: { key: "GBXUpgradeOneClick" }
        )
        ...gbxMetaTagsQuery
      }
    }
  }
  ${gbxMetaTagsQuery}
`;
export default GET_ONE_CLICK_LANDING_PAGE;
